import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { armadoEntregado } from '../../redux/actions/actionDocument';
import { ARMADO, ENTREGADO } from '../../Constantes/constantesFiltros';
import { format } from 'date-fns';
import { BsCartCheckFill, BsCartXFill } from "react-icons/bs";
import { BsBusFrontFill } from "react-icons/bs";
import { BsEmojiFrownFill, BsEmojiExpressionlessFill, BsEmojiSmileFill } from "react-icons/bs";


export default function InformesPedidosCard({id, addressEvent, dateReception, dateSend, numberDocument, name_client, state, armado: initialArmado, entregado: initialEntregado, parcial }){
       
    const dispatch = useDispatch();
    const [armado, setArmado] = useState(initialArmado);
    const [entregado, setEntregado] = useState(initialEntregado)
    const [armadoColor, setArmadoColor] = useState(initialArmado ? "#25f910" : "red");
    const [entregadoColor, setEntregadoColor] = useState(initialEntregado ? "#25f910" : "red")
           
        
    useEffect(() => {
        setArmado(initialArmado);
        setEntregado(initialEntregado);
    }, [initialArmado, initialEntregado]);
        
    const handleArmado = (e) => {
        const { value } = e.target
        console.log(value)
        if(value === ARMADO && armado === false && entregado === false){
            console.log("true")            
            setArmadoColor("#25f910");
            dispatch(armadoEntregado({
                id:id,
                armadoAux: true,
                entregadoAux: false
            }))
            setArmado(true)
            
        } else if(value === ARMADO && armado === true && entregado === false) {
            setArmadoColor("red");
            console.log("false")            
            dispatch(armadoEntregado({
                id:id,
                armadoAux: false,
                entregadoAux: false
            }))
            setArmado(false)          
        }
        
        if(value === ENTREGADO && armado === true && entregado === false){
            console.log("entregado true")            
            setEntregadoColor("#25f910")
            dispatch(armadoEntregado({
                id:id,
                armadoAux: true,
                entregadoAux: true
            }))
            setEntregado(true)
             
        } else if(value === ENTREGADO && armado === true && entregado === true){
            console.log("entregado false") 
            setEntregadoColor("red")           
            dispatch(armadoEntregado({
                id:id,
                armadoAux: true,
                entregadoAux: false
            }))
            setEntregado(false) 
        }
        
    } //asdasda
    
   
    return(
        <div className="flex flex-row justify-center">            
            <div className="flex border-b border-slate-500">
            {/* <div className="flex flex-row  bg-slate-300 hover:text-slate-400"> "flex flex-row bg-green-600 hover:text-slate-400"*/}
            <Link to={`/documentos/${id}`}>
            <div className='flex flex-row text-[11px] hover:text-[14px] pt-2  text-sky-200 hover:text-orange-400'>
                <div className='w-12'>                    
                    <p className="font-bold text-center">{numberDocument}</p>
                </div>
                <div className='pl-2 w-72'>                    
                    <p className="font-bold text-left pl-2">{name_client}</p>
                </div>
                <div className='pl-2 w-80'>                    
                    <p className="font-bold text-left pl-2">{addressEvent}</p>
                </div>
                <div className='w-20'>                    
                    <p className="font-bold text-center">{dateSend ? format(new Date(dateSend), "dd/MM/yyyy") : null}</p>
                </div>
                <div className='w-20'>                    
                    <p className="font-bold text-center">{dateReception ? format(new Date(dateReception), "dd/MM/yyyy") : null}</p>
                </div>
                
                <div className='flex flex-row w-20 pl-3'>
                <div className='w-6'>
                    {state === false && parcial === false ? <p><BsEmojiFrownFill style={{color: "red"}} size="15px"/></p> : <p><BsEmojiFrownFill style={{color: "white"}} size="15px"/></p>}
                </div>
                <div className='w-6'>
                    {state === false && parcial === true ? <p><BsEmojiExpressionlessFill style={{color: "yellow"}} size="15px"/></p> : <p><BsEmojiExpressionlessFill style={{color: "white"}} size="15px"/></p>}
                </div>
                <div className='w-6'>
                    {state === true && parcial === false ? <p><BsEmojiSmileFill style={{color: "#25f910"}} size="15px"/></p> : <p><BsEmojiSmileFill style={{color: "white"}} size="15px"/></p>}
                </div>
                </div>

                </div>
            </Link>                              
                <div className="flex flex-row">
                     
                    <div className='w-20 pl-10'>

                        {armado === false ? <button value={ARMADO} onClick={handleArmado}><BsCartXFill style={{color: armadoColor}} size="16px" pointer-events='none'/></button> 
                        : <button value={ARMADO} onClick={handleArmado}><BsCartCheckFill style={{color: "#25f910"}} size="16px" 
                        pointer-events='none'/></button>}
                    </div>
                    <div className='w-20 pl-10'>
                        {entregado === false ? <button onClick={handleArmado} value={ENTREGADO}><BsBusFrontFill style={{color: entregadoColor}} size="16px" pointer-events='none'/></button> 
                        : <button onClick={handleArmado} value={ENTREGADO}><BsBusFrontFill style={{color: entregadoColor}} size="16px" pointer-events='none'/></button>}
                    </div>                    
                </div>                
            </div>                
        </div>
    )
}